import {
   Practitioner,
   ReceptionServiceWithPractitioners,
   ReceptionServiceWithPractitionersQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';
import { ReceptionServiceId } from '@dreryk/egabinet-private-medical-service-published-language-api';
import { ServiceLocation, ServiceLocationQuery } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsGet, useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { useCqrsSearchPractitionerProvidingPrivateMedicalService } from '../../shared/queries/useCqrsSearchPractitionerProvidingPrivateMedicalServiceQuery';
import { receptionServiceTranslationKeys } from '../../translations';

type ReceptionServiceUpdateFormLoaderRenderProps = {
   practitioners: Practitioner[];
   receptionService: ReceptionServiceWithPractitioners;
   serviceLocations: ServiceLocation[];
};

type ReceptionServiceUpdateFormLoaderProps = {
   readonly id: ReceptionServiceId;
   readonly children: (renderProps: ReceptionServiceUpdateFormLoaderRenderProps) => JSX.Element;
};

export const ReceptionServiceUpdateFormLoader = (props: ReceptionServiceUpdateFormLoaderProps): JSX.Element | null => {
   const {
      data: receptionService,
      loading: receptionServiceLoading,
      error: receptionServiceError,
   } = useCqrsGet<ReceptionServiceWithPractitioners>(() => {
      const query = new ReceptionServiceWithPractitionersQuery();
      query.id = props.id;
      return query;
   });
   const {
      data: practitioners,
      loading: practitionersLoading,
      error: practitionersError,
   } = useCqrsSearchPractitionerProvidingPrivateMedicalService();

   const {
      data: serviceLocations,
      loading: serviceLocationsLoading,
      error: serviceLocationsError,
   } = useCqrsSearch<ServiceLocation>(() => {
      return new ServiceLocationQuery();
   });

   if (receptionServiceLoading || practitionersLoading || serviceLocationsLoading) {
      return <LoaderSpinner />;
   }

   if (receptionServiceError || practitionersError || serviceLocationsError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={receptionServiceTranslationKeys.update.form.errors.loadData}
            displayIndicator
         />
      );
   }

   return props.children({
      receptionService: receptionService,
      practitioners: practitioners,
      serviceLocations: serviceLocations,
   });
};
